module.exports = __webpack_public_path__ + "h5/img/logo2.262cb619.png";